<template>
  <div>
    <div class="caijimacon">
      <Tubiao></Tubiao>
      <div class="bodytitle"><span>{{ paper.tName }}</span></div>
      <p>{{ paper.tDesc }}</p>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span class="clearfixtit">验证信息</span>
         
        </div>
        <div class="text item">
          <el-input v-model="number" placeholder="请输入验证码"><i slot="prefix" class="el-input__icon el-icon-paperclip"></i></el-input>
        </div>
        <div class="text item">
          <el-input type="number" v-model="bp_money" placeholder="请输入被骗数字金额"><i slot="prefix" class="el-input__icon el-icon-bank-card"></i></el-input>
        </div>
        <div class="text item">
          <el-input type="number" v-model="sjh" placeholder="请输入被骗人手机号" clearable><i slot="prefix" class="el-input__icon el-icon-phone"></i></el-input>
        </div>
        <div class="text item">
          <el-select v-model="category_id" placeholder="请选择类别">
            <el-option v-for="item in category_id_list" :key="item.category_id" :label="item.category_name"
              :value="item.category_id"></el-option>
          </el-select>
        </div>
        <div class="tijiaobn">
          <el-button  type="text" @click="ontj">提交</el-button>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import Tubiao from "./tubiao.vue";
export default {
  components: {
    Tubiao
  },
  data() {
    return {
      yzm: '',
      number: '',
      category_id: '',
      category_id_list: [],
      bp_money: '',
      sjh:'',
      // 试卷基础信息
      paper: {
        tName: '',
        tDesc: ''
      },
    };
  },

  created() {
    //?yzm=12345
    this.yzm = this.$route.query.yzm;
    //获取题目页面标题
    this.get_title();
    this.categorys();
  },
  methods: {
    //axios获取后台api接口
    get_title() {
      let data = this.$qs.stringify({
        yzm: this.yzm
      });
      //显示loading
      this.bus.$emit("loading", true);
      this.$axios({
        method: "post",
        url: "/public/index.php/Index/question_title",
        data: data
      })
        .then(res => {
          if (res.data.code == 200) {
            // console.log(res.data)
            this.paper.tName = res.data.data.name;
            this.uid = res.data.data.id;
            //关闭loading
            this.bus.$emit("loading", false);
          } else {
            //关闭loading
            this.bus.$emit("loading", false);
            // this.$message.error(res.data.message);
            this.$toast(res.data.message, 2000);
          }
        })
        .catch(err => {
          // this.$message.error(err);
          this.$toast(err, 2000);
        });
    },
    categorys() {
      let data;
      data = this.$qs.stringify({

      })
      this.$axios({
        method: "post",
        url: "/public/index.php/Index/categorys_cjm",
        data: data
      })
        .then(res => {
          if (res.data.code == 200) {
            // console.log(res.data)
            this.category_id_list = res.data.data ? res.data.data : [];
            //跳转到题目页面
            // this.$router.push({
            //   name: 'Datika',
            //   params: {},
            //   query: { uid:uid,tName:tName }
            // })
          } else {
            // this.$message.error(res.data.message);
            this.$toast(res.data.message, 2000);
          }
        })
        .catch(err => {
          // this.$message.error(err);
          this.$toast(err, 2000);
        });
    },
    // 赋值
    ontj() {
      if (!this.number || !this.category_id || !this.bp_money || !this.sjh) {
        // this.$message.error("请输入信息!");
        this.$toast('请输入信息!', 2000);
        return
      }
      const regex_phone = /^1[3-9]\d{9}$/;
      //判断手机号格式
      if(!regex_phone.test(this.sjh)){
        this.$toast('请输入正确手机号!', 2000);
        return
      }
      let data = this.$qs.stringify({
        number: this.number,
        uid: this.uid
      });
      //显示loading
      this.bus.$emit("loading", true);
      this.$axios({
        method: "post",
        url: "/public/index.php/Index/collection_yzm",
        data: data
      })
        .then(res => {
          if (res.data.code == 200) {
            // console.log(res.data)
            let tName = this.paper.tName;
            let uid = this.uid;
            let number = this.number;
            let yzm = this.yzm;
            let category_ids = this.category_id;
            let bp_moneys = this.bp_money;
            let sjh = this.sjh;
            //跳转到题目页面
            this.$router.push({
              name: 'Datika',
              params: {},
              query: { uid: uid, tName: tName, number: number, category_id: category_ids, bp_money: bp_moneys, yzm: yzm, sjh: sjh }
            })
            //关闭loading
            this.bus.$emit("loading", false);
          } else {
            //关闭loading
            this.bus.$emit("loading", false);
            // this.$message.error(res.data.message);
            this.$toast(res.data.message, 2000);
          }
        })
        .catch(err => {
          // this.$message.error(err);
          this.$toast(err, 2000);
        });
    },
  }


}
</script>

<style scoped lang="less">
.caijimacon {
  width: 100vw;
  height: 100vh;
  background: url("../../assets/img/111.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow: hidden;

  .bodytitle {
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 20%;

    >span {
      font-family: YouSheBiaoTiHei;
      font-size: 10vw;

      letter-spacing: 0;
      font-weight: 400;
      background-image: -webkit-linear-gradient(bottom, #67b5a3, #55c5ad);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-shadow: -4px 2px 2px rgba(68, 188, 255, 0.3);
    }
  }

  .text {
    font-size: 2vh;
  }

  .item {
    margin-bottom: 18px;
    .el-select {
      width: 100%;
    }
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .clearfixtit {
    font-family: 'PingFang Heavy';
    font-size: 6vw;
   
  }

  .tijiaobn {
    margin: 4vh 0 0 0;
    margin: 0 auto;
    width: 21vw;
    height: 8vw;
    // line-height: 8vw;
    background: rgba(36, 151, 254, 1);
    border-radius: 6px;
    color: white;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .el-button--text {
      color: white;
      font-size: 4vw;
    }
  }

  .box-card {
    width: 80%;
    margin: 12vh auto;
    background: rgba(255, 255, 255, 0.7);
  }

  h2,
  p {
    text-align: center;
  }

  h2 {
    font-size: 28px;
    margin-top: 60px;
  }

  p {
    font-size: 20px;
  }
}
</style>